import { useEffect, useState } from "react";
import api from "@/lib/api";

const VERSION = "1.1";

export default function VersionBadge({ inline = false }) {
  const [online, setOnline] = useState(null);
  const [version, setVersion] = useState(VERSION);

  const ping = async () => {
    try {
      const { data } = await api.get("/health");
      setOnline(data.status === "online" && data.db);
      setVersion(data.version || VERSION);
    } catch { setOnline(false); }
  };

  useEffect(() => {
    ping();
    const t = setInterval(ping, 15000);
    return () => clearInterval(t);
  }, []);

  const label = online === null ? "CHECKING" : online ? "ONLINE" : "OFFLINE";
  const color = online === null ? "text-zinc-500" : online ? "text-green-400" : "text-red-400";
  const dotColor = online === null ? "bg-zinc-500" : online ? "bg-green-400 pulse-dot" : "bg-red-500";

  if (inline) {
    return (
      <span className={`inline-flex items-center gap-1.5 text-[10px] font-bold tracking-widest ${color}`} data-testid="version-badge-inline">
        <span className={`h-1.5 w-1.5 rounded-full ${dotColor}`}/>
        v{version} · {label}
      </span>
    );
  }
  return (
    <div className={`fixed bottom-3 left-3 z-30 inline-flex items-center gap-1.5 text-[10px] font-bold tracking-widest ${color} bg-zinc-900/80 backdrop-blur border border-zinc-800 rounded-full px-2.5 py-1`} data-testid="version-badge">
      <span className={`h-1.5 w-1.5 rounded-full ${dotColor}`}/>
      v{version} · {label}
    </div>
  );
}
